__turbopack_context__.v({
  "body": "_5K4BIG_body",
  "closeButton": "_5K4BIG_closeButton",
  "description": "_5K4BIG_description",
  "icon": "_5K4BIG_icon",
  "loader": "_5K4BIG_loader",
  "root": "_5K4BIG_root",
  "title": "_5K4BIG_title",
});
